import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import { SvgAsset } from '@ingenico/react-ui/svg-asset';
import classNames from 'classnames';
import deepEqual from 'fast-deep-equal';
import type { ReactNode } from 'react';
import { memo } from 'react';
import type { StatusChipsProps } from './statusChips.model';
import styles from './statusChips.module.scss';

function StatusChipsCpt({ label, status, componentsClassNames }: StatusChipsProps): ReactNode {
  return (
    <div
      className={classNames(styles.container, componentsClassNames?.container, {
        [styles.container__success]: status === 'success',
        [styles.container__error]: status === 'error',
        [styles.container__inherit]: status === 'inherit',
        [styles.container__warning]: status === 'warning',
        [styles.container__primary]: status === 'primary',
        [styles.container__info]: status === 'info',
      })}
    >
      <SvgAsset
        className={classNames(styles.icon, {
          [styles.icon__success]: status === 'success',
          [styles.icon__error]: status === 'error',
          [styles.icon__inherit]: status === 'inherit',
          [styles.icon__warning]: status === 'warning',
          [styles.icon__primary]: status === 'primary',
          [styles.icon__info]: status === 'info',
        })}
        image="fiber-manual-record"
      />
      <CoreTypography variant={CoreTypographyVariant.Body02Medium}>{label}</CoreTypography>
    </div>
  );
}

export const StatusChips = memo(StatusChipsCpt, deepEqual);
